import { TalentArchivingReasonEnum } from "@/api/talent/models";

/**
 * Nome padrão para o ator responsável por arquivar talentos quando
 * essa informação não estiver disponível (ex: arquivamento automático realizado pelo sistema).
 */
export const DEFAULT_ARCHIVED_ACTOR_NAME = "Sistema";

/**
 * Dicionário de motivos de arquivamento de talentos.
 * Usado para exibir labels legíveis no popup de detalhes.
 */
export const ARCHIVING_REASON_LABEL: Record<TalentArchivingReasonEnum, string> = {
  [TalentArchivingReasonEnum.CHANGE]: "Mudança",
  [TalentArchivingReasonEnum.QUIT]: "Desistência",
  [TalentArchivingReasonEnum.EXPIRED_CONTRACT]: "Contrato expirado",
  [TalentArchivingReasonEnum.INACTIVE_STATUS]: "Talento com status inativo",
};
